<template>
<div>
  <transparentheaders class="white" ref="brother"></transparentheaders>
  <div class="background">
    <div class="container">

      <div class="notice">
        <el-page-header @click.native="goback()">
        </el-page-header>
        <div class="notice_outer" v-if="noticeVisible">
          <div class="noticetitle">通知公告</div>
          <ul class="noticecontent">
            <li @click="changenoticeid(item.id)" v-for="item in noticeItems" :key="item.id">{{item.title}} <span class="r">{{item.createTime}}</span></li>

          </ul>
        </div>
        <div class="notice_inner" v-if="noticecontentVisible">
          <div class="noticetitle">通知详情</div>
          <ul>
            <li class="contenttitle">{{noticetitle}}</li>
            <li class="time_notice"><img class="timeico" src="../assets/images/time_ico.png">{{createtime}}</li>
            <li class="content_notice" v-html="noticecontent.replace(/\n/g,'<br/>')"></li>
            <li>
              <el-button class="servicebutton" @click="kefu()"><img class="service" src="../assets/images/service.png" />咨询客服</el-button>
            </li>
          </ul>
        </div>
      </div>

    </div>
  </div>

</div>
</template>

<script>
import transparentheaders from "../components/transparentheaders.vue";
import router from "../router";
import {
  newslist,
  newsdetail,
  token,
  queryById,
  home,
  chatRecordlist
} from "../api/api";
const noticeItems = []
export default {
  data() {
    return {
      noticeVisible: true,
      noticecontentVisible: false,
      noticeItems,
      noticetitle: "",
      createtime: "",
      noticecontent: "",
      youid: "",
    }
  },
  components: {
    transparentheaders
  },
  mounted() {
    this.userid = JSON.parse(
      sessionStorage.getItem("userinfo_Data")
    ).id
    newslist({
      pageNo: 1
    }).then(res => {
      if (res.data.code == 200) {
        this.noticeItems = res.data.result.records;
      }
    })
    this.gethome();
  },
  methods: {
    shownoticecontent() {
      this.noticecontentVisible = true;
      this.noticeVisible = false;

    },
    changenoticeid(e) {
      this.shownoticecontent();
      console.log(e)
      newsdetail({
        id: e
      }).then(res => {
        if (res.data.code == 200) {
          this.noticetitle = res.data.result.title
          this.createtime = res.data.result.createTime
          this.noticecontent = res.data.result.memo
        }
      })
    },
    goback() {
      if (this.noticeVisible)
        router.push("/about");

      if (this.noticecontentVisible) {
        this.noticecontentVisible = false;
        this.noticeVisible = true;
      }
    },
    gethome() {
      home().then(res => {
        if (res.data.code == 200) {
          
          this.youid = res.data.result;
        }
      });
    },
    open() {
      this.$msgbox({
        title: "提示",
        message: `${this.msg}`,
        type: "warning",
        center: true,
        confirmButtonText: "确定"
      }).then(() => {});
    },
    kefu() {
      token().then(res => {
        if (res.data.code == 200) {

        }
      });
      chatRecordlist({
        propertyId: JSON.parse(sessionStorage.getItem("indexTime"))[0].id,
        startQueryTime: JSON.parse(sessionStorage.getItem("indexTime"))[0].time,
        pageNo: 1,
        pageSize: 20
      }).then(res => {
        if (res.data.code == 200) {
          if (!this.youid) {
            this.msg = "未指定客服"
            this.open()
          }
          else {
            this.$router.push({path:'/kefu',query: {id:this.youid}})
          }
        }
      });

    },

  }
}
</script>

<style lang="scss" scoped>
.background {
  padding: 20px;
  background: rgb(234, 242, 250);
  height: 100vh;
}

.white {
  background: white;
}

.notice {
  margin: 0 auto;
  margin-top: 70px;
  padding: 30px 80px;
  background: white;
  height: 830px;

}

.noticecontent li {
  font-size: 14px;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  border-bottom: 1px solid #0a6cff;
  padding: 20px 0px 10px 0px;
  border-radius: 0px;
  display: flex;
  justify-content: space-between
}

.r {
  text-align: right;
  font-size: 12px;
  color: #999;

}

.noticetitle {
  text-align: center;
  font-size: 18px;
}

.contenttitle {
  margin-top: 20px;
  margin-bottom: 13px;
  font-size: 20px;
  color: #333;
}

.time_notice {
  color: #999;
  font-size: 13px;
}

.timeico {
  width: 15px;
  height: 15px;
  margin-bottom: 3px;
  margin-right: 8px;
}

.content_notice {
  margin-top: 20px;
  font-size: 14px;
}

>>>.el-page-header__left::after {
  display: none;
}

.service {
  margin-right: 8px;
  margin-bottom: 6px;
  margin-top: 2px;
}

.servicebutton {
  margin-right: 5px;
  padding: 5px 15px;
}

.el-button {
  background-color: rgb(255, 152, 31);
  text-align: center;
  border-radius: 20px;
  margin-top: 30px;
  font-size: 16px;
  font-family: "Microsoft YaHei";
  color: rgb(255, 255, 255);
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/notice.vue